// Packages
import ListItem from 'modules/Coupons/components/ListItem';
import PropTypes from 'prop-types';

const CouponList = ({ isLoading, items, onChange }) => {

	// Loading State
	if ( isLoading )
	{
		return (
			<div className='CouponList'>
					<ListItem isLoading={true}/>
			</div>
		)
	}


	// Empty State
	if ( items.length === 0 )
	{
		return (
			<h3 className='opacity italic'>No Coupons to show here</h3>
		)
	}


	// Data State
	return (
		<div className='CouponList'>

			{items.map((item, index) => {

				return (
						<ListItem 
							{...item} 
							key={index}
							isLoading={false}
							onChange={() => {onChange()}}
						/>
				)
				
			})}
	
		</div>
	)
}

CouponList.propTypes = {
	isLoading: PropTypes.bool,
	items: PropTypes.array,
	onChange: PropTypes.func,
}

CouponList.defaultProps = {
	isLoading: false,
	items: [],
	onChange: () => {'onChange is not set!'},
}

export default CouponList;